import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { useNavigate, useParams } from 'react-router';
import { Container } from '../../../ui/gridSystem';
import { Text } from '../../../ui/atoms';
import theme from '../../../ui/theme';
import { withMediaQueries } from '../../hoc/withMediaQueries';
import Breadcrumb from '../../../ui/atoms/Breadcrumb';
import routes from '../../../routes';
import ModalSessionResults from '../../../ui/atoms/Modals/ModalSessionResults';
import { COURSE_DETAILS_GET } from '../../redux/actions/coursedetails';
import SessionBlock from './SessionBlock';
import ModalFilters from '../../../ui/atoms/Modals/ModalFilters';
import { SESSION_USERS_RESET } from '../../redux/actions/liveEvent';

const LiveEventDetails = ({
  mediaIsPhone,
  data,
  getCourseDetails,
  sessionUsersReset,
}) => {
  const { event_id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (event_id) {
      getCourseDetails({ id: event_id });
    }
    return () => sessionUsersReset();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [event_id]);

  return (
    <>
      <Breadcrumb
        crumbs={[
          {
            label: 'Gestione eventi dal vivo',
            onClick: () => navigate(routes.liveEventList.path),
          },
          {
            label: data?.title,
          },
        ]}
      />
      <Container className="pt-0 pb-5">
        <Text type="h1" mb={8}>
          Gestione evento:
        </Text>
        <Text
          type={mediaIsPhone ? 'h3' : 'h2'}
          mb={40}
          color={theme().colors.primaryDarkGray600}
        >
          {data?.title}
        </Text>
        {(data?.session || []).map((session, si) => (
          <SessionBlock
            session={{ ...session, session_number: si + 1 }}
            key={`session-${si}`}
          />
        ))}
      </Container>
      <ModalSessionResults />
      {mediaIsPhone && <ModalFilters />}
    </>
  );
};

LiveEventDetails.propTypes = {
  //HOC: withMediaQueries
  mediaIsPhone: PropTypes.bool,
  // state
  data: PropTypes.object,
  // dispatch
  getCourseDetails: PropTypes.func,
  sessionUsersReset: PropTypes.func,
};

export default compose(
  connect(
    (state) => {
      const data = state.coursedetails;
      return { data };
    },
    (dispatch) => ({
      getCourseDetails: ({ id, hideLoader }) =>
        dispatch({ type: COURSE_DETAILS_GET._REQUEST, id, hideLoader }),
      sessionUsersReset: () => dispatch({ type: SESSION_USERS_RESET }),
    })
  ),
  withMediaQueries
)(LiveEventDetails);
